import { prompt, PromptResult } from '@mfl/common-components';
import { navigateTo } from '@mfl/framework';
import {
  PURCHASE_PLANS_URL,
  reportUserAnalyticEvent,
} from '@mfl/platform-shell';

import strings from './add-seats-prompt.strings';

export async function showAddSeatsPrompt() {
  const confirmResult = await prompt({
    aid: 'ADD_SEATS_PROMPT',
    header: strings.addMoreSeatsTitle,
    question: strings.addMoreSeatsDescription,
    width: '460px',
    separators: 'bottom',
    primaryButtonText: strings.addSeats,
    secondaryButtonText: strings.cancel,
  });

  if (confirmResult === PromptResult.Primary) {
    reportUserAnalyticEvent({
      eventName: 'navigated_to_pricing_page',
      metadata: { origin: 'add_seats_prompt' },
    });
    navigateTo(PURCHASE_PLANS_URL);
  }
}
